<template>
  <div >
    <div class="registerChenggong">
      <img src="../../static/img/chenggong.png" alt="">
      <div class="Xiazaiapp" @click="xiazai">去关注</div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        infor1:"",
      }
    },
    components: {
      prompt,
    },
    mounted () {

    },
    methods:{
      //下载app
      xiazai:function(){
        // window.location.href = "https://huitoubao2.tiancaibaoxian.com/publicweixinV2/#/?sourceCode=tchb";
        window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3OTY3MzkzMw==#wechat_redirect ";
        // window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUyODkxMTQ4NQ==&scene=124&uin=&key=&devicetype=Windows+10+x64&version=63030532&lang=zh_CN&a8scene=7&fontgear=6";
      }
    }
  }
</script>

<style scoped lang="less">
  .registerChenggong{
    position: relative;
  }
  .registerChenggong img{
    width:100%;
  }
  .Xiazaiapp{
    width:65%;
    height:45px;
    line-height:45px;
    background:#fecb0b;
    position: absolute;
    bottom:72px;
    left:18%;
    border-radius:40px;
    color:#FFFFFF;
    font-size:20px;
    text-align:center;
    box-shadow: 0px 0.02rem 0.16rem 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0.02rem 0.16rem inset rgba(0,0,0,0.5);               /* For Firefox3.6+ */
    -webkit-box-shadow:0px 0.02rem 0.16rem inset rgba(0,0,0,0.5);            /* For Chrome5+, Safari5+ */
    box-shadow:0px 0.02rem 0.16rem inset rgba(0,0,0,0.5);                   /* For Latest Opera */
  }

</style>



// WEBPACK FOOTER //
// src/pages/registerSuccess.vue